import { 
    userSettings
} from '@/globals/userSettings';

export default function renderButtons(buttons, btnClass?:string) {
    let _html = '';
    const settings = userSettings

    for(var i = buttons.length; i--;) {
        let x = buttons[i];
        const isActive = btnClass === 'asw-filter' ? settings?.states?.contrast === x.key : !!settings?.states?.[x.key];

        _html += `
            <button class="asw-btn ${ btnClass || '' } ${isActive ? 'asw-selected' : ''}" 
                    type="button" 
                    data-key="${ x.key }" 
                    title="${ x.label }"
                    aria-label="${ x.label }"
                    aria-pressed="${ isActive }">
                ${ x.icon }
                <span class="asw-translate">${ x.label }</span>
            </button>
        `;
    }
    
    return _html;
}